// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RoundedButton_wrapper__1-pQ6"};